import { render, staticRenderFns } from "./kaidanHome.vue?vue&type=template&id=57855596&scoped=true&"
import script from "./kaidanHome.vue?vue&type=script&lang=js&"
export * from "./kaidanHome.vue?vue&type=script&lang=js&"
import style0 from "./kaidanHome.vue?vue&type=style&index=0&id=57855596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57855596",
  null
  
)

export default component.exports